import _ from 'lodash';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { MODALS } from 'global-constants';

import renderInputField from 'shared/forms/RenderInputField';

import { required } from 'shared/forms/validators';
import Button from 'shared/components/Button';
import Errors from 'shared/forms/Errors';

import { requestForgotPassword } from 'shared/components/ForgotPasswordModal/ducks';
import { openModal } from 'shared/components/Modals/reducer';

import styles from './styles.module.scss';

export const FORM_NAME = 'ForgotPasswordForm';

class ForgotPasswordForm extends React.Component {
  submit(data) {
    this.props.requestForgotPassword(FORM_NAME, data);
  }
  redirectToLogin = () => {
    this.props.closeModal();
    this.props.openModal({ modalName: MODALS.LOGIN });
  };

  render() {
    const { handleSubmit, invalid, submitting, error } = this.props;

    return (
      <div className={styles.forgotPasswordWrapper}>
        <div className={styles.forgotPasswordContainer}>
          <div className={styles.pageTitle}>Forgot your Password?</div>
          <div className={styles.resetPasswordInfo}>
            No problem. Just enter the email address associated with your
            account below, and we'll send you an e-mail with instructions on how
            to reset your password.
          </div>
          <div className={styles.errors}>
            {!_.isEmpty(error) && <Errors errors={error} />}
          </div>
          <form onSubmit={handleSubmit(this.submit.bind(this))}>
            <div className="form-group">
              <label className="form-label">Email Address*</label>
              <Field
                name="email"
                component={renderInputField}
                type="email"
                placeholder="Enter Email address"
                validate={[required]}
              />
            </div>
            <div>
              <Button
                className={styles.submitBtn}
                type="submit"
                color="brand-green"
                disabled={invalid || submitting}
                data-test="forgot-password-email-instructions">
                Send Email
              </Button>
            </div>
            <div className={styles.backToSignIn}>
              I know my password,{' '}
              <span className={styles.link} onClick={this.redirectToLogin}>
                Sign in
              </span>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

ForgotPasswordForm = reduxForm({ form: FORM_NAME })(ForgotPasswordForm);

const mapDispatchToProps = {
  requestForgotPassword,
  openModal
};

export default connect(
  null,
  mapDispatchToProps
)(ForgotPasswordForm);
